export const SANDBOX_SIDEBAR_WIDTH = "180px";
export const SANDBOX_TOGGLE_BUTTON_SIZE = "24px";
